"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicDrawerController = exports.ADD_ELEMENT_STATUS = void 0;
const fym_lib_1 = require("@faceyourmanga/fym-lib");
const Utilities_1 = require("../Utilities");
var ADD_ELEMENT_STATUS;
(function (ADD_ELEMENT_STATUS) {
    ADD_ELEMENT_STATUS["ADDED"] = "ADDED";
    ADD_ELEMENT_STATUS["OVERRIDED"] = "OVERRIDED";
    ADD_ELEMENT_STATUS["UPDATED"] = "UPDATED";
    ADD_ELEMENT_STATUS["REMOVED"] = "REMOVED";
    ADD_ELEMENT_STATUS["NOT_IN_SET"] = "NOT_IN_SET";
    ADD_ELEMENT_STATUS["REQUIRED_BY_CATEGORY"] = "REQUIRED_BY_CATEGORY";
})(ADD_ELEMENT_STATUS = exports.ADD_ELEMENT_STATUS || (exports.ADD_ELEMENT_STATUS = {}));
class PublicDrawerController {
    constructor(resources, setId) {
        this.dataId = '';
        this.init(resources, setId);
    }
    regenerateDataId() {
        this.dataId = Utilities_1.stroToBtoa(Math.random() + '').substr(10, 5);
    }
    export(resources, setId) {
        return this.getData(resources, setId);
    }
    import(data, resources, setId) {
        const parsed = typeof data === 'string' ? JSON.parse(data) : data;
        if (parsed &&
            typeof resources !== 'undefined' &&
            parsed.set === setId &&
            typeof resources.set[parsed.set] !== 'undefined') {
            this.init(resources, setId);
            if (parsed.resources) {
                const drawableResources = parsed.resources;
                for (let i = 0, len = drawableResources.length; i < len; i++) {
                    try {
                        if (typeof drawableResources[i].elementId !== 'undefined' &&
                            fym_lib_1.elementExistsInSet(resources, parsed.set, drawableResources[i].elementId)) {
                            this.addElement(resources, resources.element[drawableResources[i].elementId], drawableResources[i].colors, drawableResources[i].transform);
                        }
                    }
                    catch (e) { }
                }
            }
        }
    }
    initted(resources, setId) {
        if (typeof this.data !== 'undefined' &&
            typeof resources !== 'undefined' &&
            typeof setId !== 'undefined' &&
            typeof resources.set[setId] !== 'undefined') {
            return setId === this.data.set;
        }
        return false;
    }
    getData(resources, setId) {
        if (this.initted(resources, setId))
            return this.data;
        return null;
    }
    getRawData() {
        return this.data;
    }
    getDataId() {
        return this.dataId;
    }
    init(resources, setId) {
        if (typeof resources !== 'undefined' &&
            typeof setId !== 'undefined' &&
            typeof resources.set[setId] !== 'undefined') {
            this.data = {
                set: setId,
                resources: [],
            };
            this.generateDefault(resources, setId);
            this.regenerateDataId();
        }
    }
    clear() {
        this.data = undefined;
        this.regenerateDataId();
    }
    /**
     *
     *
     * @param {IPublicResources} resources
     * @param {IPublicElement} element
     * @param {{ mappingPaletteId: MappingPaletteId; colorId: ColorId }} [colors]
     * @param {IApplyTransform} [transform]
     * @returns {(ADD_ELEMENT_STATUS | null)}
     */
    toggleElement(resources, element, colors, transform) {
        if (typeof this.data === 'undefined' ||
            typeof element === 'undefined' ||
            element === null ||
            typeof element.id === 'undefined') {
            return null;
        }
        if (!fym_lib_1.elementExistsInSet(resources, this.data.set, element.id)) {
            return ADD_ELEMENT_STATUS.NOT_IN_SET;
        }
        const currentElementIndex = this.data.resources.findIndex(drawable => drawable.elementId === element.id);
        if (currentElementIndex >= 0) {
            const categoryId = element.categories.filter((categoryId) => fym_lib_1.categoryExistsInSet(resources, this.data.set, categoryId))[0];
            if (resources.category[categoryId].drawRequired === false) {
                // Controllo se dall'elemento che sto rimuovendo dipendevano i colori di altri element
                // in caso positivo gli lascio i colori
                const currentElementColors = this.data.resources[currentElementIndex].colors;
                const dependsElements = this.data.resources.filter(drawable => drawable.elementId !== element.id &&
                    fym_lib_1.getCategoryWithColorForElementOfSet(resources, drawable.elementId, this.data.set).includes(fym_lib_1.findCategoryOfElementForSet(resources, element.id, this.data.set)));
                // ora posso rimuovere l'elemento
                dependsElements.forEach(drawable => (drawable.colors = currentElementColors));
                this.data.resources.splice(currentElementIndex, 1);
                this.regenerateDataId();
                return ADD_ELEMENT_STATUS.REMOVED;
            }
            else {
                return ADD_ELEMENT_STATUS.REQUIRED_BY_CATEGORY;
            }
        }
        return this.addElement(resources, element, colors, transform);
    }
    /**
     * Add element to drawables
     *
     * @param {IPublicResources} resources
     * @param {IPublicElement} element
     * @param {Record<MappingPaletteId, ColorId>} [colors]
     * @param {IApplyTransform} [transform]
     * @returns {(ADD_ELEMENT_STATUS | null)}
     */
    addElement(resources, element, colors, transform) {
        if (typeof this.data === 'undefined' ||
            typeof element === 'undefined' ||
            element === null ||
            typeof element.id === 'undefined') {
            return null;
        }
        if (!fym_lib_1.elementExistsInSet(resources, this.data.set, element.id)) {
            return ADD_ELEMENT_STATUS.NOT_IN_SET;
        }
        // controllo che l'elemento che voglio inserire abbia un colore che dipenda da
        // un'altra categoria ed esista un elemento di essa
        let elementHasntColorRef = fym_lib_1.getElementHasntColorRef(resources, element.id, this.data.set, this.data.resources);
        // controllo se il colore selezionato esiste nella palette,
        // se non è selezionato il colore viene messo quello di default
        colors = typeof colors !== 'undefined' && Object.keys(colors).length > 0 ? colors : undefined;
        colors = fym_lib_1.validateColorsForElement(colors, resources, element.id, this.data.set);
        // Controllo se il nuovo elemento sostituisce uno gia' esistente per la stessa categoria (colori e tranform sotto)
        {
            const replaceElementIndex = this.data.resources.findIndex(drawable => element.id !== drawable.elementId &&
                fym_lib_1.hasSameCategory(resources, this.data.set, element, resources.element[drawable.elementId]));
            if (replaceElementIndex >= 0) {
                //  Override
                this.data.resources[replaceElementIndex].elementId = element.id;
                // Setta il colore se esiste, altrimenti lascia il precedente col sanitize sul nuovo elemento
                if (typeof colors !== 'undefined') {
                    this.data.resources[replaceElementIndex].colors = colors;
                }
                else {
                    // i colori del nuovo elemento potrebbe avere mappature di colori diversi
                    const prevColor = this.data.resources[replaceElementIndex].colors;
                    this.data.resources[replaceElementIndex].colors =
                        prevColor && Object.keys(prevColor).length > 0
                            ? fym_lib_1.validateColorsForElement(prevColor, resources, element.id, this.data.set)
                            : fym_lib_1.getDefaultColorsForElement(resources, element.id, this.data.set, elementHasntColorRef);
                }
                // Mantenere le transform precedenti?
                this.data.resources[replaceElementIndex].transform = transform;
                this.regenerateDataId();
                return ADD_ELEMENT_STATUS.OVERRIDED;
            }
        }
        // Controllo se sostituire solo i colori o la transform
        {
            const currentElementIndex = this.data.resources.findIndex(drawable => drawable.elementId === element.id);
            if (currentElementIndex >= 0) {
                //  UPDATE ELEMENT COLOR OR TRANSOFORM
                /* Colors */ {
                    if (elementHasntColorRef) {
                        // caso in cui il colore di un elemento dipende da un altro che non è presente nelle drawables (es: sopracciglia capelli)
                        // forzo il colore all'elemento
                        this.data.resources[currentElementIndex].colors = {
                            ...(this.data.resources[currentElementIndex].colors || {}),
                            ...colors,
                        };
                    }
                    else {
                        // controllo se la categoria reale dell'elemento ha dipendenza di colore
                        const currentElementCategory = resources.category[fym_lib_1.findCategoryOfElementForSet(resources, element.id, this.data.set)];
                        // controllo se la categoria reale dell'elemento ha dipendenza di colore
                        if (typeof currentElementCategory.dependsCategoryPalette !== 'undefined') {
                            // Setto il colore agli elementi che hanno la categoria di dipendenza
                            const parentElements = this.data.resources.filter(e => fym_lib_1.findCategoryOfElementForSet(resources, e.elementId, this.data.set) ===
                                currentElementCategory.dependsCategoryPalette);
                            // Nonostante un elemento abbia una dipendenza di colore da una categoria,
                            // potrebbe settare dei colori di un'altra palette (es mano con polsino, dipende da faccia, ma il colore del polsino è di un'altra palette)
                            if (typeof colors === 'undefined') {
                                if (parentElements.length) {
                                    parentElements.forEach(drawable => this.addElement(resources, resources.element[drawable.elementId], colors));
                                }
                            }
                            else {
                                // Rimuovo i colori che fanno parte della palette della categoria di dipendenza e li smisto al padre,
                                // i restanti li aggiungo all'elemento
                                const colorsToDispatch = {};
                                const tmpColors = { ...colors };
                                const oldColors = this.data.resources[currentElementIndex].colors;
                                const currentMappingPaletteIds = Object.keys(tmpColors);
                                const mappinPaletteIdsOfDependsCategory = Object.keys(resources.category[currentElementCategory.dependsCategoryPalette].mappingPalette || {});
                                for (let mappingPaletteId of currentMappingPaletteIds) {
                                    if (mappinPaletteIdsOfDependsCategory.includes(mappingPaletteId)) {
                                        colorsToDispatch[mappingPaletteId] = tmpColors[mappingPaletteId];
                                        delete tmpColors[mappingPaletteId];
                                        if (oldColors && oldColors[mappingPaletteId]) {
                                            delete oldColors[mappingPaletteId];
                                        }
                                    }
                                }
                                this.data.resources[currentElementIndex].colors = { ...oldColors, ...tmpColors };
                                if (parentElements.length) {
                                    parentElements.forEach(drawable => this.addElement(resources, resources.element[drawable.elementId], colorsToDispatch));
                                }
                            }
                        }
                        else {
                            if (typeof colors !== 'undefined' && Object.keys(colors).length > 0) {
                                const oldColors = this.data.resources[currentElementIndex].colors;
                                this.data.resources[currentElementIndex].colors = { ...oldColors, ...colors };
                            }
                        }
                    }
                }
                /* Transform */ {
                    if (typeof transform !== 'undefined')
                        this.data.resources[currentElementIndex].transform = fym_lib_1.validateApplyTransformForElement(transform, resources, element.id, this.data.set);
                }
                this.regenerateDataId();
                return ADD_ELEMENT_STATUS.UPDATED;
            }
        }
        // Se non esiste gia' lo inserico
        // Controllo se esiste un elemento che dipende dai colori del nuovo elemento
        if (!elementHasntColorRef) {
            const dependsElements = this.data.resources.filter(resource => resource.elementId !== element.id &&
                fym_lib_1.getCategoryWithColorForElementOfSet(resources, resource.elementId, this.data.set).includes(fym_lib_1.findCategoryOfElementForSet(resources, element.id, this.data.set)));
            if (dependsElements.length) {
                colors = colors || dependsElements[0].colors;
                dependsElements.forEach(drawable => (drawable.colors = undefined));
            }
        }
        this.data.resources.push({
            elementId: element.id,
            colors: colors || fym_lib_1.getDefaultColorsForElement(resources, element.id, this.data.set, elementHasntColorRef),
            transform: fym_lib_1.validateApplyTransformForElement(transform, resources, element.id, this.data.set),
        });
        this.regenerateDataId();
        return ADD_ELEMENT_STATUS.ADDED;
    }
    generateDefault(resources, setId) {
        if (this.initted(resources, setId)) {
            const defaultElements = PublicDrawerController.generateDefault(resources, setId);
            this.data = { set: setId, resources: [] };
            // this.data.resources = defaultElements.map((element: IPublicElement) => ({
            // 	element: ele8ment.id,
            // 	colors: {},
            // 	transform: defaultApplyTransform,
            // }))
            defaultElements.forEach((element) => {
                return this.addElement(resources, element);
            });
        }
    }
    generateRandom(resources, setId) {
        if (this.initted(resources, setId)) {
            const randomElements = PublicDrawerController.generateRandom(resources, setId);
            this.data = { set: setId, resources: [] };
            randomElements.forEach((element) => {
                const colors = undefined;
                const colors2 = PublicDrawerController.getRandomColorForElement(resources, element.id, setId);
                return this.addElement(resources, element, colors2);
            });
        }
    }
    static getRandomColorForElement(resources, elementId, setId) {
        const element = resources.element[elementId];
        if (element.mappingCategoryPaletteColors) {
            const elementCategoryId = fym_lib_1.findCategoryOfElementForSet(resources, elementId, setId);
            const elementCategory = resources.category[elementCategoryId];
            if (elementCategory) {
                const elementMappingCategory = element.mappingCategoryPaletteColors[elementCategoryId];
                const result = {};
                const mappingPaletteIds = Object.keys(elementMappingCategory || {});
                mappingPaletteIds.forEach(mappingPaletteId => {
                    if (elementCategory.mappingPalette && elementCategory.mappingPalette[mappingPaletteId]) {
                        const paletteId = elementCategory.mappingPalette[mappingPaletteId].palette;
                        const palette = resources.palette[paletteId];
                        const colors = Object.keys(palette.colors);
                        const randomColorIndex = Math.round(Math.random() * colors.length);
                        result[mappingPaletteId] = colors[randomColorIndex];
                    }
                });
                return result;
            }
        }
    }
    /**
     *
     *
     * @static
     * @param {IPublicResources} resources
     * @param {SetId} setId
     * @returns {Array<IPublicElement>}
     */
    static generateDefault(resources, setId) {
        const requiredCategories = [].concat
            .apply([], resources.set[setId].groups.map((group_id) => resources.group[group_id].categories))
            .filter(categoryId => resources.category[categoryId] && resources.category[categoryId].drawRequired);
        const result = [];
        for (const category_id of requiredCategories) {
            const category = resources.category[category_id];
            const elementsIds = category ? category.elements : [];
            if (elementsIds.length > 0) {
                if (category.defaultElement && resources.element[category.defaultElement]) {
                    result.push(resources.element[category.defaultElement]);
                }
                else {
                    result.push(resources.element[elementsIds[Math.round(Math.random() * elementsIds.length - 1)]]);
                }
            }
        }
        return result;
    }
    /**
     *
     *
     * @static
     * @param {IPublicResources} resources
     * @param {SetId} setId
     * @returns {Array<IPublicElement>}
     */
    static generateRandom(resources, setId) {
        const categories = [].concat.apply([], resources.set[setId].groups.map((group_id) => resources.group[group_id].categories));
        return categories
            .filter(categoryId => resources.category[categoryId].drawRequired || Math.random() >= 0.5)
            .map(categoryId => {
            const category = resources.category[categoryId];
            const elementsIds = category ? category.elements : [];
            if (elementsIds.length > 0) {
                const randomElementId = PublicDrawerController.getRandomElementIdByCategoryId(resources, categoryId, elementsIds);
                if (randomElementId && resources.element[randomElementId]) {
                    return resources.element[randomElementId];
                }
            }
        })
            .filter(element => typeof element !== 'undefined');
    }
    static getRandomElementIdByCategoryId(resources, category_id, onlyThisElements) {
        const rand = Math.random();
        if (typeof onlyThisElements !== 'undefined') {
            if (onlyThisElements.length <= 0)
                return undefined;
            const maxElements = onlyThisElements.length - 1;
            return onlyThisElements[Math.round(rand * maxElements)];
        }
        if (resources.category[category_id].elements.length <= 0)
            return undefined;
        const maxElements = resources.category[category_id].elements.length - 1;
        return resources.category[category_id].elements[Math.round(rand * maxElements)];
    }
}
exports.PublicDrawerController = PublicDrawerController;
